module.exports = __webpack_public_path__ + "img/picture12.535f7851.jpg";